import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CurrentUser } from 'src/app/authentication/models/current-user.interface';
import { getCurrentUser } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getExtensionPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { PresenceContactFilterOptions } from '../models/presence-contact-filter-option';
import { PresenceContactPrivileges } from '../models/presence-contact-privileges';
import { PresenceContactRegisterListItem } from '../models/presence-contact-register-results.model';
import { PresenceContactRegister } from '../presence-contact-register';
import * as PresenceContactRegisterActions from '../state/presence-contact-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-presence-contact-register',
    styleUrls: ['./presence-contact-register.component.scss'],
    templateUrl: './presence-contact-register.component.html',
    standalone: false
})
export class PresenceContactRegisterComponent extends PresenceContactRegister {
   presenceContactPrivileges$: Observable<PresenceContactPrivileges>;
   currentUser$: Observable<CurrentUser | null>;

   constructor(public store: Store) {
      super(store);
      this.presenceContactPrivileges$ = store.pipe(select(getExtensionPrivileges));
      this.currentUser$ = store.pipe(select(getCurrentUser));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: PresenceContactFilterOptions[] = [
                  {
                     field: 'Extension.AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
                  {
                     field: 'Extension.IsArchived',
                     operation: FilterOperations.EqualTo,
                     type: 'boolean',
                     value: false,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = ['name', 'number', 'onCall', 'dndStatus', 'office', 'departments', 'optionsMenu'];
   }

   onOpenDialog(event: { callDetail: any }) {
      this.store.dispatch(PresenceContactRegisterActions.openDialog(event));
   }

   onInitiateDirectedCall(event: { initiateDirectedCallData: any }) {
      this.store.dispatch(PresenceContactRegisterActions.initiateDirectedCall(event));
   }

   onEdit(presenceContact: PresenceContactRegisterListItem): void {
      this.store.dispatch(PresenceContactRegisterActions.editPresenceContact({ presenceContact }));
   }
}
